interface ParsedOriginUrl {
  hostname: string;
  subdomain: string;
  isValid: boolean;
}

function toRegExp(envRegex: string | undefined): RegExp | null {
  if (!envRegex) return null;
  const match = envRegex.match(/^\/(.+)\/([gimsuy]*)$/);
  if (match) {
    return new RegExp(match[1], match[2]);
  }
  return new RegExp(envRegex);
}

export function parseOriginUrl(origin: string): ParsedOriginUrl {
  const getEnvironmentRegex = (): RegExp | null => {
    const prPreviewRegex = toRegExp(import.meta.env.VITE_PR_PREVIEW_REGEX);
    if (prPreviewRegex && origin.match(prPreviewRegex)) {
      return toRegExp(import.meta.env.VITE_PR_PREVIEW_REGEX);
    }
    if (
      import.meta.env.VITE_APP_ENV === "development" ||
      import.meta.env.VITE_APP_ENV === "qa" ||
      import.meta.env.VITE_APP_ENV === "staging" ||
      import.meta.env.VITE_APP_ENV === "production" ||
      import.meta.env.VITE_APP_ENV === "uat"
    ) {
      return toRegExp(import.meta.env.VITE_DOMAIN_REGEX);
    }
    if (import.meta.env.VITE_APP_ENV === "localhost") {
      return toRegExp(import.meta.env.VITE_LOCALHOST_REGEX);
    }
    return null;
  };

  try {
    const regex = getEnvironmentRegex();
    if (!regex || origin.match(regex)) {
      return {
        hostname: "",
        subdomain: "",
        isValid: false,
      };
    }
    const url = new URL(origin);
    const hostname = url.hostname;
    const parts = hostname.split(".");
    const subdomain = parts[0];

    return {
      hostname,
      subdomain,
      isValid: true,
    };
  } catch {
    return {
      hostname: "",
      subdomain: "",
      isValid: false,
    };
  }
}
